"use strict"

import {query, mutation, subscription} from "./graphql"
import { discussionClient } from "@/plugins/hylable-sdk"

const gql = discussionClient.gql
const DELETE_BATCH_SIZE = 10

export default {
  async list(params){
    let items = []
    let nextToken = null
    for(;;) {
      const res = await gql.run(query.listDiscussions, {cid: params.cid, nextToken: nextToken})
      items = items.concat(res.items)
      nextToken = res.nextToken
      if(!nextToken) break
    }
    return {[params.cid]: items.map(translate)}
  },
  async get(params){
    await gql.request.gql.cache.reset()
    const res = await gql.run(query.getDiscussion, {id: params.id})
    return translate(res)
  },
  Subscribe(params, onChangeCb, onDeleteCb) {
    gql.subscribe(subscription.onChangeDiscussion, params, (d) => onChangeCb(translate(d)), params.cid)
    if (onDeleteCb) {
      gql.subscribe(subscription.onDeleteDiscussion, params, (d) => onDeleteCb(translate(d)), `${params.cid}-del`)
    }
  },
  Unsubscribe(id){
    gql.unsubscribe(id)
    gql.unsubscribe(`${id}-del`)
  },
  async Create(params){
    const data = await gql.run(mutation.create, {input: params})
    if(data.error) return Promise.reject(data.error)
    return JSON.parse(data.result)
  },
  async Update(params){
    const data = await gql.run(mutation.update, {input: params})
    if(data.error) return Promise.reject(data.error)
    return JSON.parse(data.result)
  },
  async Del(params) {
    if (params.length === 0) return

    for (let i = 0; i < params.length; i += DELETE_BATCH_SIZE) {
      const batch = params.slice(i, i + DELETE_BATCH_SIZE)
      const data = await gql.run(mutation.del, {input: batch})
      if(data.error) return Promise.reject(data.error)
    }
  },
  async GetAudioUrl(params){
    const data = await gql.run(query.getAudioUrl, params)
    if(data.error) return Promise.reject(data.error)
    return JSON.parse(data.result)
  },
  async Analyze(params){
    const data = await gql.run(mutation.analyze, params)
    if(data.error) return Promise.reject(data.error)
    return JSON.parse(data.result)
  },
}

function translate(discussion){
  if (!discussion) return

  const d = { ...discussion, group: { ...(discussion.group || {}) } }

  if (typeof d.analysis === "string") {
    try { d.analysis = JSON.parse(d.analysis) } catch {}
  } else if (d.analysis == null) {
    delete d.analysis
  }

  if (typeof d.stats === "string") {
    try { d.stats = JSON.parse(d.stats) } catch {}
  }

  d.group.seats = d.group.seats || []
  return d
}
